// FIXED: Adjusted pathing to step up exactly one directory to 'src', then into client_forms
import FormStructure from '../client_forms/solepower/form_structure';

export const config = {
  clientKey: 'D0FC2C05-0BD0-409F-B350-6AF719A33F88',
};

const apiUrl = `https://inquiries.catereasewebtools.com/WebInquiryEnTake.aspx`;

export const store = {
  formData: {
    FirstName: "",
    LastName: "",
    Email: "",
    TelNumber: "",
    clientname: "", 
    EventDate: "",
    Category: "",
    SiteName: "", 
    PlannedGuestCount: "", 
    StartTime: "",      
    EndTime: "",        
    Operation: [],
    Reference: "",
    WorkingWithPlanner: "No", 
    PlannerName: "",   
    EventExtra2: "",   
    Notes: ""
  },
  currentStep: 0,
  requiredFields: {
    0: ["EventDate", "Category", "SiteName"], 
    1: ["PlannedGuestCount", "StartTime", "WorkingWithPlanner"], 
    2: ["FirstName", "LastName", "Email", "TelNumber", "clientname", "Reference"]
  }
};

export function updateFormField(name, value) {
  store.formData[name] = value;
}

export function getValidationError(fieldName) {
  const value = String(store.formData[fieldName] || "");
  const fieldConfig = FormStructure.fields[fieldName];
  
  if (!fieldConfig) return null;

  for (const validation of fieldConfig.validations) {
    if (validation.type === 'required') {
      if (!value || value.trim() === "") {
        return validation.message;
      }
    }
    
    if (validation.type === 'regex' && value !== "") {
      const regex = new RegExp(validation.pattern);
      if (!regex.test(value)) {
        return validation.message;
      }
    }
    
    if (validation.type === 'dateinfuture' && value !== "") {
        const localTodayStr = new Date().toLocaleDateString('sv-SE'); 
        if (value <= localTodayStr) {
            return validation.message || "Event date must be a future date.";
        }
    }
  }
  return null;
}

export function isStepValid() {
  const fieldsInStep = store.requiredFields[store.currentStep] || [];
  if (fieldsInStep.length === 0) return true;

  return fieldsInStep.every(fieldName => {
    const value = store.formData[fieldName] || "";
    const error = getValidationError(fieldName);
    return String(value).trim() !== "" && error === null;
  });
}